var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.haveItems
    ? _c(
        "v-speed-dial",
        {
          attrs: { top: "", right: "", direction: "bottom" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function () {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          dark: "",
                          fab: "",
                          color: "primary",
                          small: "",
                          "aria-label": _vm.btnAriaLabelClose,
                        },
                        model: {
                          value: _vm.visible,
                          callback: function ($$v) {
                            _vm.visible = $$v
                          },
                          expression: "visible",
                        },
                      },
                      [
                        _vm.visible
                          ? _c("v-icon", [_vm._v("mdi-close")])
                          : _c("v-icon", [_vm._v("mdi-view-module")]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            4080455169
          ),
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm._v(" "),
          _vm._l(_vm.items, function (item, index) {
            return _c("speed-dial-item", {
              key: index,
              attrs: { "content-button-config": item },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }